var dayjs = require('dayjs');

var duration = require('dayjs/plugin/duration')
dayjs.extend(duration);

var isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween);

import 'core-js/features/array/at';
import { live, notifyAll } from './live';
import { now as fakeNow } from '../stream-day';
import { orderTimeslots, getStartDate, getRunStartDate } from '../timeslot';

let schedule = {
    schedule: [],
    playingNow: undefined,
    currentGameIndex: -1,
    nextRun: undefined,
    next5: [],
    toCallOnRefresh: [],
    lastScheduleSignature: '',

    callWhenRefreshed: (fn) => {
        schedule.toCallOnRefresh.push(fn);
    },

    getTotalDonationsOffset: () => {
        return live.getTotalDonationOffset();
    },

    // Runs on every /live poll: projected_start moves for every later slot the moment
    // staff close out the current one, so the derived schedule can never be cached.
    refreshSchedule: () => {
        schedule.refreshScheduleRemote();
    },

    // Both live in js/timeslot.js: the reveal pages need the same two rules, and two
    // copies drifting apart is how a schedule ends up right on one page and wrong on
    // the next.
    orderTimeslots: (timeslots) => orderTimeslots(timeslots, (orphans) => {
        console.warn("Timeslots orphaned from the chain:", orphans);
    }),

    getStartDate,
    getRunStartDate,

    refreshScheduleRemote: () => {
        // Breaks are dropped except the leading one and the one on air right now: if the
        // current slot (the overnight "Nanna%") is filtered out, setSchedule() cannot find
        // it and slices from the top, so the break screen shows yesterday's runs.
        const currentId = live.getCurrentRun()?.id;
        const filteredSchedule = schedule
            .orderTimeslots(schedule.fetchSchedule())
            .filter((l, i) => l.type === 'run' || (l.type === 'break' && (i === 0 || l.id === currentId)));

        schedule.setSchedule(filteredSchedule);

        // The subscribers restart animations, so only wake them when the schedule the
        // viewer can see actually moved — not on every 15s poll.
        const signature = schedule.currentGameIndex + '|' + JSON.stringify(
            filteredSchedule.map(run => [run.id, schedule.getStartDate(run)])
        );
        if (signature === schedule.lastScheduleSignature) return;
        schedule.lastScheduleSignature = signature;

        console.log("SCHEDULE CHANGED:", schedule.schedule, "PLAYING NOW:", schedule.playingNow, "INDEX:", schedule.currentGameIndex);
        notifyAll(schedule.toCallOnRefresh, 'callWhenRefreshed');
    },

    setSchedule: (runs) => {
        schedule.schedule = runs;
        // Playing now must be the slot the backend marks as current
        let currentRun = live.getCurrentRun();

        const currentRunIndex = runs.findIndex(run => run.id === currentRun.id);

        const slicedSchedule = runs.filter((run, i) => i >= currentRunIndex);
        schedule.currentGameIndex = currentRunIndex;
        schedule.playingNow = slicedSchedule.at(0);
        schedule.nextRun = slicedSchedule.at(1);
        schedule.next5 = slicedSchedule.slice(1, 7);
    },

    showSchedulePreview: () => {
        const runPreviewUl = document.querySelector('#run-preview ul');
        runPreviewUl.innerHTML = '';
        const seizureWarningText = '⚠ !! ';
        if (typeof schedule.playingNow !== 'undefined') {
            let seizureWarning = schedule.playingNow?.submission?.seizure_warning;
            runPreviewUl.appendChild(schedule.getNewPreviewRunElement(schedule.playingNow, `PLAYING NOW: ${seizureWarning ? seizureWarningText : ''}`));
        }
        let i = 1;
        schedule.next5.forEach(run => {
            let seizureWarning = run?.submission?.seizure_warning;
            runPreviewUl.appendChild(schedule.getNewPreviewRunElement(run, `NEXT RUN #${i}: ${seizureWarning ? seizureWarningText : ''}`));
            i++;
        });
    },

    getNewPreviewRunElement: (run, prefix) => {
        let now = dayjs(fakeNow());
        const startDate = schedule.getStartDate(run);
        let startsIn = dayjs.duration(now.diff(startDate));

        const isPast = now.isAfter(startDate);
        const startsInText = isPast ? "started since" : "starts in";

        let runElement = document.createElement('li');
        runElement.innerHTML = `${prefix}${run.name} ${run.submission?.category} (est. ${schedule.getDurationFromSeconds(run.duration).humanize()}, ${startsInText}: ${startsIn.humanize()})`;

        return runElement;
    },

    fetchSchedule: () => {
        return live.liveEventData?.timeslots ?? [];
    },

    getPlayingNow: () => {
        return live.getCurrentRun();
    },

    getTimeslotById: (timeslotId) => {
        timeslotId = parseInt(timeslotId);
        console.log(`Searching for run ${timeslotId}`, schedule.schedule);
        let filteredRuns = schedule.schedule.filter(run => {
            return run.id === timeslotId;
        });
        console.log(filteredRuns);
        return filteredRuns[0] ?? [];
    },

    getNextRun: (index) => {
        return schedule.next5[index] ?? [];
    },

    updateCurrentTime: () => {
        const now = dayjs(fakeNow());
        document.querySelector('#current-time').innerHTML = now.format();
        document.querySelector('#date>.date-date').innerHTML = now.format('DD-MM-YYYY');
        document.querySelector('#time>.date-time').innerHTML = now.format('HH:mm');
    },

    // Who is on screen right now. These read playingNow, so they live with the schedule
    // rather than with the live payload -- they used to sit in live.js and reach back
    // into schedule, which was the last dependency pointing the wrong way.
    getRunner: (ord) => {
        return schedule.getPlayingNow().submission?.runners.filter(r => r.order === ord - 1)[0] ?? null;
    },

    // The override is per timeslot, so it replaces every plate that has a runner behind
    // it -- plate 1 always shows it, plate 2 stays empty on a solo run.
    getRunnerName: (ord) => {
        const runner = schedule.getRunner(ord);
        const override = schedule.playingNow?.player_name_override;
        if (override && (runner || ord === 1)) return override;
        return runner?.user?.name ?? '';
    },

    getRunnerSocials: (ord) => {
        return schedule.getRunner(ord)?.user?.layout_socials ?? [];
    },

    getRunnerSocialsData: (ord) => {
        return schedule.getRunnerSocials(ord)
            .filter(social => social.type === 'twitch' || social.type === 'youtube')
            .map(function (social) {
                const handle = social?.handle ?? '';
                const type = social?.type ?? '';
                let icon = '';
                if (type === 'twitch') {
                    icon = new URL('../../resources/infobar/icon_twitch.png', import.meta.url);
                } else if (type === 'youtube') {
                    icon = new URL('../../resources/infobar/icon_youtube.png', import.meta.url);
                }

                return { handle: handle, icon: icon };
            }) ?? [];
    },

    getHostName: () => {
        return schedule.playingNow?.reader ?? '';
    },

    getCouch: () => {
        return schedule.playingNow?.couch ?? '';
    },

    getBreakScreenHost: () => {
        return schedule.getHostName();
    },

    getDurationFromSeconds: (seconds) => {
        return dayjs.duration({ hours: Math.floor(seconds / 3600), minutes: (seconds % 3600) / 60, seconds: seconds % 60 })
    },
};

export { schedule };
window.schedule = schedule;
// Deprecated alias: this module was called `oengus` when the schedule came from Oengus.
window.oengus = schedule;